import React from 'react';
import '../styles/loader.css'; 

const Loader = () => {
    let LoaderImg = 'https://static.igem.wiki/teams/5066/global/loader-trans.gif';

    return (
        <div className="loader select-none">
            <img src={LoaderImg} alt="Loading..." />
        </div>
    );
};

export default Loader;
